import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { AuthProvider } from "../context/AuthContext";
import "../styles/App.css";
import Layout from "./Layout";
import Cashout from "./Pages/Cashout";
import Home from "./Pages/Home";
import Jobs from "./Pages/Jobs";
import Login from "./Pages/Login";
import Setting from "./Pages/Setting";
import UpgradeRequest from "./Pages/UpgradeRequest";
import Withdrawsetting from "./Pages/WithdrawSetting";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import UserHistory from "./UserHistory/UserHistory";
function App() {
  return (
    <Router>
      <AuthProvider>
        <Layout>
          <Switch>
            <PublicRoute exact path="/login" component={Login} />
            <PrivateRoute exact path="/" component={Home} />
            <PrivateRoute exact path="/setting" component={Setting} />
            <PrivateRoute exact path="/cashout-request" component={Cashout} />
            <PrivateRoute exact path="/user/:userId" component={UserHistory} />
            <PrivateRoute
              exact
              path="/withdraw-setting"
              component={Withdrawsetting}
            />
            <PrivateRoute exact path="/jobs" component={Jobs} />
            <PrivateRoute
              exact
              path="/upgrad-request"
              component={UpgradeRequest}
            />
          </Switch>
        </Layout>
      </AuthProvider>
    </Router>
  );
}
export default App;
